export const degrees = [
  {
    value: 'bs-mecheng',
    college: 'coe',
    program: 'Mechanical and Industrial Engineering',
    degree: 'B.S. Mechanical Engineering',
    description: "Mechanical engineering involves the design, development, and manufacture of machinery and devices to transmit power or to convert energy from thermal to mechanical form in order to power the modern world and its machines. Its current practice has been heavily influenced by recent advances in computer hardware and software.",
    link: "http://catalog.northeastern.edu/undergraduate/engineering/mechanical-industrial/bsme/"
  },
  {
    value: 'bs-induseng',
    college: 'coe',
    program: 'Mechanical and Industrial Engineering',
    degree: 'B.S. Industrial Engineering',
    description: "Industrial engineering involves the design and analysis of systems that include people, equipment, and materials and their interactions and performance in the workplace. An industrial engineer collects this information and evaluates alternatives to make decisions that best advance the goals of the enterprise.",
    link: "http://catalog.northeastern.edu/undergraduate/engineering/mechanical-industrial/bsie/"
  },
  {
    value: 'ba-gdesign',
    college: 'camd',
    program: 'Art + Design',
    degree: 'B.F.A. Design',
    description: "Design is the practice-based discipline raising important questions about—and providing significant answers to—how we live. Designers are needed when we don’t know what is needed. Designers propose alternative futures and create new choices using design principles and processes to create, compose, and construct meaning in diverse knowledge fields. Designers seek a broad understanding of principles and systems of perception, communication, and action. Concentrations in design practices are graphic and information design, interaction design, and experience design.",
    link: "http://catalog.northeastern.edu/undergraduate/arts-media-design/art-design/design-bfa/"
  },
  {
    value: 'bs-compsci',
    college: 'khoury',
    program: 'Computer Science',
    degree: 'B.S. Computer Science',
    description: "The Bachelor of Science in Computer Science focuses on the fundamentals of program design, software development, computer organization, systems and networks, theories of computation, principles of languages, and advanced algorithms and data.",
    link: "http://catalog.northeastern.edu/undergraduate/computer-information-science/computer-science/bscs/"
  },
  {
    value: 'ba-compsci',
    college: 'khoury',
    program: 'Computer Science',
    degree: 'B.A. Computer Science',
    description: "The Bachelor of Arts in Computer Science offers a similar curriculum to the BS, with slightly fewer CS requirements to allow students to study a foreign language and have a wider choice of electives.",
    link: "http://catalog.northeastern.edu/undergraduate/computer-information-science/computer-science/bacs/"
  }
];
